export default __webpack_public_path__ + "static/media/loadingMine.b63182de.gif";